export const TITLE = 'Time limit (seconds)';
export const PLACEHOLDER = '3600';
export const CAPTION = 'Leaving this blank or 0 would mean that there is no time limit for this quiz.';
export const END_ENHANCER = 'seconds';
